import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-devtpartner',
  templateUrl: './devtpartner.component.html',
  styleUrls: ['./devtpartner.component.scss'],
})
export class DevtpartnerComponent {}
